import Actions from 'flow/actions';
import { OperatorKey, QueueKey } from 'flow/types/EntityKeys';
import { AppDispatch } from 'flow/types/Redux';
import {
    storeSelectedQueue,
    storeSelectedOperator,
} from 'flow/utils/supervisor-utils';
import { addSupervisorLogEntry } from 'flow/utils/browser-utils';
import wrappedLocalStorage from 'flow/utils/local-storage-utils';
import { isOperatorKey, isQueueKey } from 'flow/utils';

const KEY_SELECTED_OPERATOR_LOCAL_STORAGE = 'supervisorSelectedOperator';
const KEY_SELECTED_QUEUE_LOCAL_STORAGE = 'supervisorSelectedQueue';

const setSelectedQueueInStore = (key: 'all' | QueueKey) => ({
    type: Actions.SET_SUPERVISOR_SELECTED_QUEUE,
    data: key,
});

const setSelectedOperatorInStore = (key: 'all' | OperatorKey) => ({
    type: Actions.SET_SUPERVISOR_SELECTED_OPERATOR,
    data: key,
});

export const setSelectedQueue =
    (key: 'all' | QueueKey) => (dispatch: AppDispatch) => {
        storeSelectedQueue(key);
        dispatch(setSelectedQueueInStore(key));

        const filterType = key === 'all' ? 'ALL' : 'SPECIFIC QUEUE';
        const logString = `Queue filter set: ${filterType}`;
        addSupervisorLogEntry(logString);
    };

export const setSelectedOperator =
    (key: 'all' | OperatorKey) => (dispatch: AppDispatch) => {
        storeSelectedOperator(key);
        dispatch(setSelectedOperatorInStore(key));

        const filterType = key === 'all' ? 'ALL' : 'SPECIFIC GROUP';
        const logString = `Group filter set: ${filterType}`;
        addSupervisorLogEntry(logString);
    };

export const valuePassesIsTypeQueueKeyCheck = (
    key?: string,
): key is QueueKey => {
    return isQueueKey(key);
};

export const loadSelectedQueueFromLocalStorage =
    () => (dispatch: AppDispatch) => {
        const key = wrappedLocalStorage.getItem(
            KEY_SELECTED_QUEUE_LOCAL_STORAGE,
        );
        if (key !== 'all' && !valuePassesIsTypeQueueKeyCheck(key)) return;
        dispatch(setSelectedQueue(key));
    };

export const valuePassesIsTypeOperatorKeyCheck = (
    key?: string,
): key is OperatorKey => {
    return isOperatorKey(key);
};

export const loadSelectedOperatorFromLocalStorage =
    () => (dispatch: AppDispatch) => {
        const key = wrappedLocalStorage.getItem(
            KEY_SELECTED_OPERATOR_LOCAL_STORAGE,
        );
        if (key !== 'all' && !valuePassesIsTypeOperatorKeyCheck(key)) return;
        dispatch(setSelectedOperatorInStore(key));
    };
